<template>
  <div id="app" v-if="browserSupported">
    <transition name="router-transition" mode="out-in">
       <router-view />
    </transition>
  </div>
  <div class="browser-not-supported" v-else>
    <loading-logo :autoplay="false" />
    <div>We apologize for the inconvenience but your browser is not supported. </div>
    <div>Please update your browser to the latest version or download one from the links below</div>
    <div><a href="https://www.mozilla.org/en-US/firefox/new/">Mozilla Firefox</a></div>
    <div><a href="https://www.opera.com/download">Opera</a></div>
    <div><a href="https://www.microsoft.com/en-us/edge">Microsoft Edge 79 and above</a></div>
    <div><a href="https://www.google.com/chrome/">Google Chrome</a></div>
  </div>
</template>

<script>
  import UAParser from 'ua-parser-js'
  import 'webrtc-adapter';
  import LoadingLogo from "./components/LoadingLogo";

  export default {
    components: {LoadingLogo},
    data: () => ({
      browserSupported: true,
    }),
    created() {
      var parser = new UAParser();
      let result = parser.getResult();
      let browser = result.browser.name;
      let majorVersion = parseInt(result.browser.major);
      if(browser === 'Edge' && majorVersion < 79 ){
        this.browserSupported = false
      }
    }
  }
</script>

<style lang="scss">
  @import "App";
</style>
